import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { api } from 'lib/axios';
import {
  ResendEmailError,
  ResendEmailRequest,
  ResendEmailResponse,
} from './types';

export const useResendEmail = () => {
  const { isError, isLoading, data, mutateAsync, error } = useMutation<
    ResendEmailResponse,
    AxiosError<ResendEmailError>,
    ResendEmailRequest,
    ResendEmailResponse
  >((args) =>
    api.post('/auth/resend_mail_with_validation', args).then((res) => res.data)
  );

  return {
    resend: mutateAsync,
    isError,
    isLoading,
    data,
    error,
  };
};
